import Constant from '@/const';
import axios from 'axios';

const getTotalData = () => {
  try {
    const response = axios.get(
      Constant.apiUrl.concat('/report/visitors/dashboard/total'),
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default getTotalData;
